// AUTO-GENERATED — do not edit. Source: reviewed Git commerce/report_sales_copy projection
// Input: business/ishvaram/data/commerce/report_sales_copy.generated.yaml

export interface ReportSalesFaq {
  q: string;
  a: string;
}

export interface ReportSalesLocale {
  eyebrow: string | null;
  title: string;
  description: string | null;
  hero_pain: string | null;
  hero_vedic: string | null;
  lead: string | null;
  fit: string | null;
  why_now: string | null;
  checkpoints: string[];
  what_inside: string[];
  trust_lines: string[];
  faqs: ReportSalesFaq[];
  value_focus: string | null;
}

export const reportSalesCopyByPlanId = {
  annual_forecast: {
    plan_id: "annual_forecast",
    catalog_sku: "ISH-DR-007",
    intent: "chart_report",
    status: "active",
    content_slug: "annual-forecast",
    meta_description:
      "Varshphal report: month-by-month forecast for the next 12 months built from your solar return chart, current mahadasha, and transit positions.",
    en: {
      eyebrow: "Annual Forecast 2026-27",
      title: "Annual Forecast (Varshphal) — Next 12 Months in Your Chart | Ishvaram",
      description:
        "A personal Annual Forecast (varshphal) for the year ahead - month-by-month dasha and transit timing, the windows that favour you, and the ones to plan around.",
      hero_pain:
        "Why does this year feel different — and you can't put your finger on what shifted?",
      hero_vedic:
        "Every year your solar return chart (Varshphal) re-casts. Combined with your current mahadasha and the year's planetary transits, it tells you which months open and which need patience.",
      lead: "A generic yearly rashifal reads the same for millions. Your varshphal is built from your own chart - the running mahadasha and antardasha, this year's Shani and Jupiter transits over your houses, and the specific months they turn supportive or heavy.",
      fit: "Best when you want to time the year ahead - career moves, money decisions, marriage, travel, or major commitments - to your own chart.",
      why_now:
        "Most people start the year with intentions; few start it with the planetary pattern of their own chart for the year. The window the year opens is shorter than you think.",
      checkpoints: [
        "Month-by-month timing for the next 12 months, not a generic yearly blurb",
        "Your running mahadasha and antardasha and what each is ripening",
        "Shani (Saturn) and Jupiter transits over your houses, with dates",
        "The strong windows to act and the heavy windows to plan around",
      ],
      what_inside: [
        "Solar return chart (Varshphal) — your chart re-cast for this birth year",
        "Month-by-month forecast: career, finance, relationships, health, family",
        "Mahadasha + antardasha alignment with this year's transits",
        "Jupiter, Saturn and Rahu transit impact specific to your moon sign",
        "Auspicious dates per month for important decisions",
        "Upay calendar — which remedy to start in which month",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Varshphal calculated per Tajik Neelkanthi tradition",
        "Transits cross-checked against authoritative Panchang references",
        "Monthly breakdowns, not a vague yearly summary",
      ],
      faqs: [
        {
          a: "From your next birthday (solar return) — that's when your Varshphal chart re-casts. If your birthday is 3 months away the report covers from then forward; if it just passed, the report starts immediately and runs 12 months.",
          q: "When does the 12-month period start?",
        },
        {
          a: "No. A horoscope is sun-sign + transits and applies to everyone with your rashi. The Varshphal is your specific chart's annual forecast — month-level granularity, dasha-aware, calibrated to your birth details.",
          q: "Is this the same as a horoscope?",
        },
        {
          a: "They complement each other. Brihat Kundali is the full lifetime read; Varshphal is the 12-month operational view. Many readers buy the Brihat once and the Varshphal every year on their birthday.",
          q: "Do I need to combine this with the Brihat Kundali?",
        },
      ],
      value_focus: "Month-by-month timing for the next 12 months, not a generic yearly blurb",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  baby_name_report: {
    plan_id: "baby_name_report",
    catalog_sku: "ISH-DR-013",
    intent: "chart_report",
    status: "active",
    content_slug: "baby-name",
    meta_description:
      "Personal baby-name report: the child's janma nakshatra and pada, the auspicious starting syllables (namkaran akshar), and 30+ curated names with meanings and numerology fit.",
    en: {
      eyebrow: null,
      title: "Baby Name Report — Janma Nakshatra Syllables & 30+ Names | Ishvaram",
      description:
        "Personal baby-name report: the child's janma nakshatra and pada, the auspicious starting syllables (namkaran akshar), and 30+ curated names with meanings and numerology fit.",
      hero_pain:
        "Why does choosing your child's first name feel heavier than every other decision — like it will shape a life you can't yet see?",
      hero_vedic:
        "In namkaran, the first syllable is chosen from the child's janma nakshatra and pada so the name carries the Moon's blessing from birth. The Baby Name Report gives the exact syllables your child's nakshatra opens, then 30+ names that fit them.",
      lead: null,
      fit: null,
      why_now:
        "A namkaran syllable is fixed by the nakshatra the child is born into, so the naming window is real. Choosing the name from the chart, not a trending list, is the blessing you can give once.",
      checkpoints: [],
      what_inside: [
        "The child's janma nakshatra and pada, computed from birth details",
        "Auspicious starting syllables (namkaran akshar) the nakshatra and pada open",
        "30+ curated names for those syllables, each with meaning and root",
        "Numerology fit — how each name's number sits with the child's birth number",
        "Syllables and patterns to avoid for this nakshatra",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Starting syllables come from the engine-computed janma nakshatra and pada, not a generic chart",
        "Every suggested name is checked for numerology fit with the birth number",
        "Names are curated with meanings, not scraped from a popularity list",
      ],
      faqs: [
        {
          a: "A free list is not tied to your child's chart. The Baby Name Report first computes the janma nakshatra and pada, gives the exact auspicious syllables those open, and only then suggests names — so the name carries the nakshatra's blessing.",
          q: "How is this different from a free baby-name list?",
        },
        {
          a: "Date, time, and place of birth. The Moon's nakshatra and pada at birth decide the starting syllables, so the birth time should be as accurate as possible.",
          q: "What details do I need for the child?",
        },
        {
          a: "The report tells you whether its first syllable matches the child's nakshatra and how its numerology sits with the birth number, so you can keep it, adjust the spelling, or choose from the fitted list.",
          q: "What if we already have a name in mind?",
        },
      ],
      value_focus: "The child's janma nakshatra and pada, computed from birth details",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  brihat_kundali: {
    plan_id: "brihat_kundali",
    catalog_sku: "ISH-DR-004",
    intent: "chart_report",
    status: "active",
    content_slug: "brihat-kundali",
    meta_description:
      "Brihat Kundali reading: every house, planet, dasha and upay for your chart. Built from your birth details using Swiss Ephemeris, written like a senior Jyotishi sat with you.",
    en: {
      eyebrow: null,
      title: "Brihat Kundali — Full Vedic Birth Chart Reading | Ishvaram",
      description:
        "Brihat Kundali reading: every house, planet, dasha and upay for your chart. Built from your birth details using Swiss Ephemeris, written like a senior Jyotishi sat with you.",
      hero_pain:
        "Why does life feel harder than it should — even when nothing on the outside is wrong?",
      hero_vedic:
        "Your Brihat Kundali reveals the planetary pattern most pandits never name aloud: which graha is creating the friction, which dasha you are walking through, and which upay actually moves the needle.",
      lead: null,
      fit: null,
      why_now:
        "Most people come back to their Brihat Kundali at three moments — career stall, marriage decision, family conflict. Better to know the pattern before the moment arrives.",
      checkpoints: [],
      what_inside: [
        "All 12 bhavs read in plain language — what each house is doing for you, not textbook definitions",
        "Mahadasha + antardasha timeline with what to expect in the current and next period",
        "Lagna, Moon, and Navamsa cross-read — the three lenses every senior Jyotishi uses",
        "Yogas in your chart (Raj, Dhan, Gaja-Kesari, etc.) and what they unlock",
        "Doshas (Mangal, Kaal Sarp, Pitra, Sade Sati) checked with specific remedies — not generic mantras",
        "Readable 16+ page private PDF, usually ready through a secure Ishvaram report link in about 2 minutes",
      ],
      trust_lines: [
        "Calculated with Swiss Ephemeris (the arc-second astronomical standard)",
        "Public delivery and rating proof is shown only from verified paid-report records",
        "Written using Brihat Parashara Hora Shastra principles, not Western astrology",
      ],
      faqs: [
        {
          a: "Free Kundli generators give you the chart wheel and stop there. The Brihat Kundali reading interprets every house, identifies the active mahadasha, names the yogas working in your favour, flags the doshas that need remedies, and gives you a personalised upay plan you can re-read when decisions come up.",
          q: "How is this different from a free Kundli I can get anywhere?",
        },
        {
          a: "The upay in your Brihat Kundali are matched to the specific graha causing friction in your chart — not a generic 'wear ruby for Sun' list. Indian families have followed this lineage of remedies for centuries because they target the planetary pattern, not the symptom.",
          q: "Will the upay (remedies) actually work?",
        },
        {
          a: "Date of birth, time of birth (as accurate as possible — the panchang changes within minutes), and place of birth (city is enough; we resolve the exact coordinates).",
          q: "What birth details do I need?",
        },
        {
          a: "Reports are usually ready in about 2 minutes after payment. The PDF opens through a secure Ishvaram report link; if checkout recovery is needed, use the recovery email or write to support@ishvaram.com.",
          q: "How quickly do I receive it?",
        },
        {
          a: "Use the best estimate available. Birth-time uncertainty can change house and timing interpretation, and formal birth-time rectification is not included in this report.",
          q: "What if I don't know my exact birth time?",
        },
      ],
      value_focus:
        "All 12 bhavs read in plain language — what each house is doing for you, not textbook definitions",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  career_report: {
    plan_id: "career_report",
    catalog_sku: "ISH-DR-010",
    intent: "chart_report",
    status: "active",
    content_slug: "career-report",
    meta_description:
      "Career Kundali reading: 10th house, Saturn placement, current mahadasha, and the timing of your next career break — by Vedic shastra, not a generic horoscope.",
    en: {
      eyebrow: "Career Report",
      title: "Career Report — 10th House, Saturn & Career Timing | Ishvaram",
      description:
        "A personal Vedic career report for 10th house, D10/Dasamsa, Shani, Jupiter, dasha timing, wealth yogas, and career upay.",
      hero_pain:
        "Why does your hard work never seem to turn into results — even when others with less effort move ahead?",
      hero_vedic:
        "Your 10th house, your Shani placement and the dasha you're walking through shape career timing. The Career Report explains the chart factors linked with delay and more supportive windows.",
      lead: "Career does not move only because effort increases. Your 10th house, D10, Shani, Jupiter, Sun, Budh, and active dasha decide when work becomes visible and when patience is smarter.",
      fit: "Best when promotions, job changes, business timing, or income growth feel delayed despite consistent effort.",
      why_now:
        "Career mahadashas typically last 6–19 years. Knowing whether the current one is opening doors or closing them changes the decisions you make this year.",
      checkpoints: [
        "10th house and D10/Dasamsa career direction",
        "Current dasha and transit support for job or business",
        "Wealth yogas and blocked income patterns",
        "Career upay matched to the graha causing delay",
      ],
      what_inside: [
        "10th house (karma bhav) full read — what kind of career your chart actually supports",
        "Saturn (Shani) placement and Sade Sati status — the senior Jyotishi check most miss",
        "Current mahadasha + antardasha and what they mean for career timing",
        "Yogas that boost or block career — Raj yoga, Dhan yoga, Saraswati yoga",
        "Specific upay for the graha currently obstructing growth (not 'wear blue sapphire' guesswork)",
        "Profession suggestions matched to your chart, not a generic 'engineer or lawyer' list",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Built from Swiss Ephemeris + Brihat Parashara Hora Shastra",
        "Sade Sati timing cross-checked against authoritative Panchang references",
        "Public delivery and rating proof is shown only from verified paid-report records",
      ],
      faqs: [
        {
          a: "It tells you which kinds of work your chart supports, which dasha period favours risk vs stability, and what upay to do for the planet currently blocking growth. The decision stays yours — but you make it with the planetary pattern in view.",
          q: "Will the report tell me which job to take?",
        },
        {
          a: "Sade Sati is not a curse. It's Shani giving you the lesson your chart already needed. The report tells you which phase (rising, peak, setting), what to avoid, and which upay specifically work for Shani in your chart's placement.",
          q: "I'm in Sade Sati. Is everything going to fail?",
        },
        {
          a: "Yes — 10th house + 11th house + Mercury + Sun together read business chart very specifically. The report covers entrepreneurship explicitly when those factors are strong in your chart.",
          q: "Does this work for entrepreneurs / business owners?",
        },
      ],
      value_focus: "10th house and D10/Dasamsa career direction",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  dosha_remedy_plan: {
    plan_id: "dosha_remedy_plan",
    catalog_sku: "ISH-DR-009",
    intent: "remedy_dosha",
    status: "active",
    content_slug: "dosha-remedy-plan",
    meta_description:
      "Chart-specific dosha diagnosis and remedy plan: Mangal, Kaal Sarp, Pitra, Shani and other dosha checks with severity, cancellation rules and safe upay.",
    en: {
      eyebrow: "Dosha Report",
      title: "Why follow a dosha upay before checking your chart?",
      description:
        "A chart-specific Dosha Report for Mangal, Kaal Sarp, Pitra, Shani and other pressure checks, with severity, cancellation, and safe upay.",
      hero_pain: "Why do people keep telling you to do upay before confirming the dosha?",
      hero_vedic:
        "A dosha should be diagnosed by rule, severity and cancellation first. The Dosha Remedy Plan shows which dosha actually fires in your chart and which upay is safe for that pattern.",
      lead: "A dosha report should reduce fear, not create it. The right read checks whether a dosha actually fires, whether cancellation applies, which life area is affected, and which upay is safe before any strong remedy is suggested.",
      fit: "Best when one or more doshas have been mentioned and you need the safe next step instead of a generic remedy list.",
      why_now:
        "Wrong remedies waste money and can create fear. The safer path is to confirm the dosha, check cancellation, then follow the smallest effective upay consistently.",
      checkpoints: [
        "Mangal, Kaal Sarp, Pitra, Shani and other chart pressure checks",
        "Severity and cancellation before remedies",
        "Affected life areas separated clearly",
        "Safe upay routine: mantra, donation, vrata, shanti, or product guidance",
      ],
      what_inside: [
        "Detected doshas with the rule that fired, not a generic fear-based list",
        "Severity and cancellation checks before any remedy is recommended",
        "Life areas affected: marriage, career, family, health, money or spiritual discipline",
        "Safe upay routine: mantra, donation, vrata, puja timing and behavioural correction",
        "Matched remedy products only where the chart supports them",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Engine checks dosha rules before recommending remedies",
        "Cancellation factors are evaluated before severity is finalised",
        "Remedy guidance is chart-specific and avoids gemstone overclaiming",
      ],
      faqs: [
        {
          a: "Yes. It focuses on the doshas available in the Ishvaram engine and explains which one is actually active for your chart.",
          q: "Will it check multiple doshas?",
        },
        {
          a: "No. The report checks cancellation and severity first, then recommends the lighter or stronger upay your chart actually supports.",
          q: "Will it recommend a strong ritual immediately?",
        },
      ],
      value_focus:
        "Your safe upay (remedy) sequence — mantra, donation, vrata, matched to your chart",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  gemstone_report: {
    plan_id: "gemstone_report",
    catalog_sku: "ISH-DR-012",
    intent: "chart_report",
    status: "active",
    content_slug: "gemstone-recommendation",
    meta_description:
      "Personal ratna and rudraksha report: which gemstone your kundali actually needs by lagna and dasha, the wearable rudraksha equivalent, and the full dhaaran vidhi — metal, finger, day, and mantra.",
    en: {
      eyebrow: null,
      title: "Rudraksha & Ratna Report — The Stone Your Chart Needs | Ishvaram",
      description:
        "Personal ratna and rudraksha report: which gemstone your kundali actually needs by lagna and dasha, the wearable rudraksha equivalent, and the full dhaaran vidhi — metal, finger, day, and mantra.",
      hero_pain:
        "Why does the gemstone someone told you to wear feel like it changed nothing — or made things heavier?",
      hero_vedic:
        "A ratna strengthens a graha, so the wrong stone strengthens the wrong planet. The Rudraksha & Ratna Report reads your lagna, dasha, and functional benefics first, then names the stone your chart needs and the rudraksha you can wear instead.",
      lead: null,
      fit: null,
      why_now:
        "A ratna keeps working for years, so wearing the wrong one quietly strengthens the wrong graha the whole time. Confirming the stone before you buy the metal is the cheaper mistake to avoid.",
      checkpoints: [],
      what_inside: [
        "Which ratna your chart needs, ranked by lagna lord, functional benefics, and active dasha",
        "Stones to avoid — the grahas your chart does not want strengthened",
        "The wearable rudraksha equivalent (mukhi) when a ratna is not suitable or affordable",
        "Full dhaaran vidhi: metal, finger, weight, day, and the graha mantra for activation",
        "When to wear it — the dasha window where the stone actually helps",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Stone selection is ranked by lagna and dasha, not by rashi alone",
        "Lower-cost rudraksha alternatives are included where the tradition recognises one",
        "Dhaaran vidhi follows classical activation, not shop guesswork",
      ],
      faqs: [
        {
          a: "Rashi-based stone charts ignore your lagna and dasha, which is why they often strengthen a graha your chart does not want strong. The report reads your functional benefics first, so the ratna is matched to your chart, not your sun sign.",
          q: "Can't I just wear the stone for my rashi?",
        },
        {
          a: "The report gives a wearable rudraksha equivalent for each ratna, providing a lower-cost traditional option for the same graha.",
          q: "What if I cannot afford the recommended ratna?",
        },
        {
          a: "Yes. The dhaaran vidhi covers metal, finger, weight, the right day, and the graha mantra for activation, so the stone is worn correctly instead of just bought.",
          q: "Does it tell me how to wear it?",
        },
      ],
      value_focus:
        "Which ratna your chart needs, ranked by lagna lord, functional benefics, and active dasha",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  lal_kitab_report: {
    plan_id: "lal_kitab_report",
    catalog_sku: "ISH-DR-014",
    intent: "chart_report",
    status: "active",
    content_slug: "lal-kitab",
    meta_description:
      "Personal Lal Kitab report: your Lal Kitab chart, ancestral debts (rin), blind and sleeping planets, and the simple low-cost totke matched to your chart.",
    en: {
      eyebrow: null,
      title: "Lal Kitab Remedy Report — Rin, Blind Planets & Totke | Ishvaram",
      description:
        "Personal Lal Kitab report: your Lal Kitab chart, ancestral debts (rin), blind and sleeping planets, and the simple low-cost totke matched to your chart.",
      hero_pain:
        "Why does the same money or family trouble keep circling back — as if a debt you never took is still being collected?",
      hero_vedic:
        "Lal Kitab reads your chart as a ledger of rin (ancestral debts) and blind or sleeping planets. The Lal Kitab Remedy Report names which rin is active in your chart and gives the simple, low-cost totke that clear it.",
      lead: null,
      fit: null,
      why_now:
        "Lal Kitab totke are cheap and quiet, but only the ones matched to your active rin do anything. Knowing which debt is being collected is what turns a totka from folklore into a remedy.",
      checkpoints: [],
      what_inside: [
        "Your Lal Kitab chart, read in its own house system — not a standard kundali overlay",
        "Ancestral debts (rin) that are active and the life area each one presses on",
        "Blind and sleeping planets — grahas giving no result until they are woken correctly",
        "Simple, low-cost totke matched to your chart, in the order Lal Kitab prescribes",
        "What to avoid — the common totke that backfire when done for the wrong planet",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "The Lal Kitab chart is read in its own house-and-debt system, not a repackaged kundali",
        "Totke are matched to the active rin, sequenced the way Lal Kitab prescribes",
        "Low-cost, home-doable remedies — no expensive ritual pushed by default",
      ],
      faqs: [
        {
          a: "Lal Kitab uses its own house system and reads the chart as ancestral debts (rin) and blind or sleeping planets. It points at low-cost totke rather than gemstones or long pujas, so the remedy path is different from a standard kundali reading.",
          q: "How is Lal Kitab different from my normal kundali reading?",
        },
        {
          a: "No. Lal Kitab totke are deliberately simple and low-cost — a donation, a placement, a small daily act. The report gives only the ones matched to your active rin, in the right order.",
          q: "Are the totke complicated or expensive?",
        },
        {
          a: "Yes, as accurately as possible. The Lal Kitab house placements decide which rin and which blind planets are active, and those depend on the birth time.",
          q: "Do I need my birth time?",
        },
      ],
      value_focus:
        "Your Lal Kitab chart, read in its own house system — not a standard kundali overlay",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  mahadasha_forecast: {
    plan_id: "mahadasha_forecast",
    catalog_sku: "ISH-DR-002",
    intent: "chart_report",
    status: "active",
    content_slug: "mahadasha-forecast",
    meta_description:
      "Mahadasha forecast report: current mahadasha and antardasha, next 12 months of sub-periods, transition timing, and graha-specific upay.",
    en: {
      eyebrow: "Mahadasha Forecast",
      title: "Mahadasha Forecast — Current Dasha & Next 12 Months | Ishvaram",
      description:
        "A 12-month Mahadasha Forecast with current mahadasha, antardasha, transition timing, decision windows, and graha-specific upay.",
      hero_pain: "Why does timing change everything even when your effort stays the same?",
      hero_vedic:
        "Mahadasha decides the background climate of your life. The forecast reads the active graha period, the antardasha shift, and the next 12 months so decisions match timing.",
      lead: "Mahadasha is the background climate of your life. The same effort can feel blocked or supported depending on the active graha and sub-period. This report turns that timing into practical next steps.",
      fit: "Best when you are deciding whether to act, wait, change job, start something, or understand why a phase has shifted.",
      why_now:
        "The same action taken in the wrong dasha window feels blocked. The same action in the right window becomes easier. This report helps you stop fighting timing blindly.",
      checkpoints: [
        "Current mahadasha and antardasha from Moon nakshatra",
        "Next transition points and month-level timing",
        "Career, money, marriage, family, health, and spiritual focus",
        "Graha-specific upay for the active period",
      ],
      what_inside: [
        "Current mahadasha and antardasha interpreted from your Moon nakshatra",
        "Next 12 months of sub-periods with practical timing notes",
        "Career, money, marriage, family, health, and spiritual focus by active graha",
        "Transition points where the emotional or practical climate changes",
        "Graha-specific upay for the period instead of generic yearly advice",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Vimshottari dasha is computed from Moon nakshatra, not guessed from sun sign",
        "Forecast connects dasha with transits and practical decision windows",
        "Built for repeat reading across the year, not one-time curiosity",
      ],
      faqs: [
        {
          a: "No. Mahadasha is the long planetary period behind your life timing. Annual forecast is the year view. This report focuses on the active dasha and the next 12 months of sub-period movement.",
          q: "Is Mahadasha the same as an annual forecast?",
        },
        {
          a: "Birth time improves the house context, but Moon nakshatra drives Vimshottari dasha. Use the most accurate time available so the supporting chart remains clean.",
          q: "Do I need exact birth time?",
        },
        {
          a: "It gives action, caution, and upay windows by sub-period. It avoids fixed guarantees and explains the graha pattern behind each period.",
          q: "Will it tell me good and bad months?",
        },
      ],
      value_focus: "Current mahadasha and antardasha from Moon nakshatra",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  marriage_report: {
    plan_id: "marriage_report",
    catalog_sku: "ISH-DR-005",
    intent: "chart_report",
    status: "active",
    content_slug: "marriage-report",
    meta_description:
      "Marriage Kundali reading: 7th house analysis, Mangal Dosh check, Kundali Milan with partner, and the upay that actually shifts marriage karma.",
    en: {
      eyebrow: "Marriage Report",
      title: "Marriage Report — Kundali Milan, 7th House & Mangal Dosh | Ishvaram",
      description:
        "A family-shareable Marriage Report for Kundali Milan, 7th house, Mangal Dosh, D9/Navamsha, dasha timing, and practical upay.",
      hero_pain: "Why does every relationship end the same way — even when the person was right?",
      hero_vedic:
        "Your 7th house, your Mangal placement and your Venus dasha decide the pattern. The Marriage Report names which one is repeating in your life and what to do about it.",
      lead: "Marriage matching should not stop at a score. The 7th house, Mangal placement, Nadi/Bhakoot, D9/Navamsha, and both partners' dasha timing decide whether the match is stable, delayed, or needs upay.",
      fit: "Best before families decide, when the match looks good but one chart point or repeated doubt needs a proper Vedic cross-check.",
      why_now:
        "Indian families take Kundali Milan seriously for a reason: 7th house karma repeats across relationships until the pattern is named and addressed.",
      checkpoints: [
        "Full 36-point Gun Milan with the weak kootas explained",
        "Mangal Dosh, Nadi, Bhakoot, Gana, and cancellation checks",
        "D9/Navamsha and dasha timing for marriage stability",
        "Clear strengths, risks, remedies, and family-shareable summary",
      ],
      what_inside: [
        "7th house full read — what kind of partner your chart is actually pulling in",
        "Mangal Dosh check (manglik or not, and how severe)",
        "Kundali Milan (Ashtakoota Gun Milan) with partner if you provide their birth details",
        "Nadi, Bhakoot, Gana dosh check and which can be remedied",
        "Marriage timing window per your current and next dasha",
        "Specific upay — not generic mantras — for the dosha in your chart",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Ashtakoota Gun Milan calculated per Brihat Parashara Hora Shastra",
        "Both-chart inputs are required before any Kundali Milan interpretation is generated",
        "Nadi normalisation and cancellation rules are applied before Nadi Dosh is reported",
      ],
      faqs: [
        {
          a: "We can still run the 7th house + Mangal Dosh + dasha analysis on your chart alone. Kundali Milan with partner is the cleanest read when both birth times are accurate, but the marriage karma in your chart is readable independently.",
          q: "What if my partner doesn't know their exact birth time?",
        },
        {
          a: "Manglik placements only matter in specific combinations. The report tells you whether yours is severe (1st, 4th, 7th, 8th, 12th house from Lagna/Moon/Venus), nominally Mangal (cancelled by other yogas), or not Mangal at all. Most online Mangal calculators flag false positives.",
          q: "Is Mangal Dosh really a problem?",
        },
        {
          a: "Nadi Dosh has specific cancellation rules in Vedic shastra (same nakshatra of different pada, exception nakshatras, etc.). The report applies those rules first and gives upay only for the residual dosh that actually remains.",
          q: "Will the upay break my Nadi Dosh?",
        },
        {
          a: "Free Gun Milan gives you a number (X out of 36) and stops. The Marriage Report explains which kootas are weak, which are saved by other chart factors, what the dasha is going to do to the marriage in the next 5–7 years, and the specific upay for your dosha — not someone else's.",
          q: "How is this different from a free Gun Milan score?",
        },
      ],
      value_focus: "Full 36-point Gun Milan with the weak kootas explained",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  muhurat_report: {
    plan_id: "muhurat_report",
    catalog_sku: "ISH-DR-008",
    intent: "timing_muhurat",
    status: "active",
    content_slug: "muhurat-report",
    meta_description:
      "Personal muhurat report for important decisions: city panchang, purpose-specific timing, avoid windows, sankalp, and ritual checklist from your birth chart.",
    en: {
      eyebrow: "Personal Muhurat Report",
      title: "Muhurat Report — Personal Auspicious Timing & Sankalp | Ishvaram",
      description:
        "A personal Muhurat report for purpose-specific timing, avoid windows, panchang, sankalp, and ritual checklist.",
      hero_pain: "Why does a shubh time from the internet still feel wrong for your specific work?",
      hero_vedic:
        "A real muhurat depends on your purpose, city, Moon sign, dasha, tithi, nakshatra, yoga, karana, Rahu Kaal and personal chart pressure. This report brings those layers together.",
      lead: "A public choghadiya slot is only the outer layer. A cleaner muhurat checks city panchang, purpose, Moon sign, dasha pressure, avoid windows, and the sankalp you should take before starting.",
      fit: "Best before launches, purchases, griha pravesh, travel, naming, rituals, or family decisions where timing matters.",
      why_now:
        "Muhurat is useful only before the decision is made. Once the event is fixed, the best you can do is damage control; this report helps you choose the cleaner window first.",
      checkpoints: [
        "Purpose-specific timing instead of a generic table",
        "Tithi, nakshatra, yoga, karana, weekday, and choghadiya",
        "Rahu Kaal, Yamagandam, Gulika Kaal, and personal dasha pressure",
        "Sankalp wording and practical ritual checklist",
      ],
      what_inside: [
        "Purpose-specific timing guidance for launch, purchase, griha pravesh, travel, naming, ritual, or family decision",
        "Panchang layer: tithi, nakshatra, yoga, karana, weekday and choghadiya",
        "Avoid windows: Rahu Kaal, Yamagandam, Gulika Kaal and personal dasha pressure",
        "Best available windows ranked with practical recommendation notes",
        "Sankalp wording and ritual checklist so the timing is actionable",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Built from city panchang and chart-aware timing rules",
        "Avoid-window scoring includes Rahu Kaal and dasha context",
        "Designed to beat public choghadiya tables with personal context",
      ],
      faqs: [
        {
          a: "A public choghadiya table gives a general day/night period for a city. The Muhurat Report adds your purpose, birth-chart context, avoid windows, and sankalp checklist so you know which window to use and why.",
          q: "How is this different from a choghadiya table?",
        },
        {
          a: "Use this for early timing guidance. A full wedding muhurat still needs deeper family constraints, both charts, and final pandit confirmation because marriage timing has stricter rules.",
          q: "Can I use it for marriage?",
        },
        {
          a: "Your birth details, city, purpose, and date range. A wider date range gives the engine more room to find a clean window.",
          q: "What details do I need?",
        },
      ],
      value_focus: "Purpose-specific timing instead of a generic table",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  numerology_report: {
    plan_id: "numerology_report",
    catalog_sku: "ISH-DR-011",
    intent: "chart_report",
    status: "active",
    content_slug: "numerology-life",
    meta_description:
      "Personal numerology (Ank Jyotish) report: your mulank and bhagyank, the graha each rules, name-number harmony, lucky numbers and days, and the year ahead — read against your kundali.",
    en: {
      eyebrow: null,
      title: "Numerology Life Report — Mulank, Bhagyank & Lucky Numbers | Ishvaram",
      description:
        "Personal numerology (Ank Jyotish) report: your mulank and bhagyank, the graha each rules, name-number harmony, lucky numbers and days, and the year ahead — read against your kundali.",
      hero_pain:
        "Why do your numbers keep pulling you toward the same delays — no matter how hard you try to change course?",
      hero_vedic:
        "Your mulank and bhagyank are ruled by the same grahas sitting in your kundali. The Numerology Life Report names which graha each number carries, where your name-number fights your birth number, and the upay that settles the pattern.",
      lead: null,
      fit: null,
      why_now:
        "A birth number does not change, but the personal year it runs through does. Reading the current cycle before a big decision is the difference between forcing a door and walking through an open one.",
      checkpoints: [],
      what_inside: [
        "Mulank (birth number) and bhagyank (destiny number) with the graha each one rules",
        "Name-number harmony check — where your name works with your birth number and where it fights it",
        "Lucky numbers, days, and directions matched to your ruling grahas",
        "Year-ahead numerology cycle and the months it turns supportive or heavy",
        "Numerology upay: name correction, number discipline, and the graha remedy behind it",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Mulank and bhagyank are computed from your date of birth, then read against your kundali's grahas",
        "Name-number analysis follows classical Ank Jyotish, not a Western pattern",
        "Upay stays chart-specific — no fear-based number changes",
      ],
      faqs: [
        {
          a: "A free calculator gives you the mulank and bhagyank numbers and stops. The Numerology Life Report explains the graha each number rules, checks whether your name-number supports or fights your birth number, and gives the upay for the pattern your chart actually carries.",
          q: "How is this different from a free numerology calculator?",
        },
        {
          a: "Numerology runs from your date of birth and name, so those are enough for the core report. Birth time only sharpens the kundali cross-read of your ruling grahas.",
          q: "Do I need my birth time?",
        },
        {
          a: "Only where the chart supports it. Most cases are handled with a spelling adjustment or number discipline rather than a full name change — the report gives the safe, smallest correction first.",
          q: "Will it tell me to change my name?",
        },
      ],
      value_focus:
        "Mulank (birth number) and bhagyank (destiny number) with the graha each one rules",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  pitra_dosh: {
    plan_id: "pitra_dosh",
    catalog_sku: "ISH-DR-003",
    intent: "remedy_dosha",
    status: "active",
    content_slug: "pitra-dosh",
    meta_description:
      "Pitra Dosh personal report: engine-verified diagnosis, 9th-house ancestral pattern, cancellation checks, dasha activation and safe upay.",
    en: {
      eyebrow: "Pitra Dosh Report",
      title: "Pitra Dosh Report — 9th House, Ancestors & Upay | Ishvaram",
      description:
        "A personal Pitra Dosh report for Sun, 9th house, Rahu/Ketu, cancellation checks, dasha activation, and safe ancestral upay.",
      hero_pain: "Why do family, career, or peace patterns keep repeating across generations?",
      hero_vedic:
        "Pitra Dosh should be confirmed through the Sun, 9th house, Rahu/Ketu, Saturn, and cancellation factors before any tarpan, shradh, or donation routine is recommended.",
      lead: "Pitra Dosh is serious enough that it should be confirmed before any tarpan, shradh, donation, or puja sequence is started. The report checks the rule, severity, cancellation, and activation window first.",
      fit: "Best when recurring family or career blocks are being explained as ancestral karma and you want the chart verified first.",
      why_now:
        "Pitra Dosh upay should not start from fear. The safer order is diagnosis, severity, cancellation, activation, then the smallest effective upay.",
      checkpoints: [
        "Sun, 9th house, 9th lord, Rahu/Ketu and Saturn checks",
        "Cancellation factors before severity is finalised",
        "Family, father-line, career, and money pattern interpretation",
        "Tarpan, shradh, mantra, donation, or lighter upay sequence",
      ],
      what_inside: [
        "Engine-verified Pitra Dosh check using Sun, 9th house, nodes, and 9th lord pressure",
        "Cancellation factors so a weak or neutral chart is not treated as a serious dosh",
        "Dasha activation window: when the ancestral pattern is likely to feel active",
        "Affected life areas: family peace, father line, career block, money pattern, or spiritual duty",
        "Safe upay sequence: tarpan, shradh, donation, mantra, and consistency notes",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Uses rule-backed Pitra Dosh detection before recommending any upay",
        "Cancellation checks are evaluated before severity is finalised",
        "Designed for Indian family decisions where ancestral karma is a serious concern",
      ],
      faqs: [
        {
          a: "The calculator tells you whether a Pitra Dosh signature appears. The private report explains why it appears, whether cancellation reduces it, when it activates, and which upay sequence is safe for your chart.",
          q: "How is this different from the free Pitra Dosh calculator?",
        },
        {
          a: "No. The report checks severity first. Mild or cancelled patterns may need a lighter mantra/donation routine instead of a larger ritual.",
          q: "Does everyone need tarpan or shradh?",
        },
        {
          a: "It can, especially when the 9th house, Sun, Saturn, or dasha links ancestral duty with karma and authority. The report explains which life area is actually touched in your chart.",
          q: "Can Pitra Dosh affect career?",
        },
      ],
      value_focus: "Sun, 9th house, 9th lord, Rahu/Ketu and Saturn checks",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  sade_sati: {
    plan_id: "sade_sati",
    catalog_sku: "ISH-DR-001",
    intent: "remedy_dosha",
    status: "active",
    content_slug: "sade-sati",
    meta_description:
      "Personal Sade Sati report: natal Shani, current phase, dasha context, pressure areas, and chart-specific Shani upay from your kundali.",
    en: {
      eyebrow: "Sade Sati Report",
      title: "Sade Sati Report — Shani Phase, Dates & Upay | Ishvaram",
      description:
        "A personal Sade Sati report for Shani phase, natal Saturn, dasha context, pressure areas, and chart-specific upay.",
      hero_pain: "Why does this Shani phase feel heavy even when you are doing everything right?",
      hero_vedic:
        "Sade Sati is read from your Moon sign, but the real answer comes from natal Shani, current dasha, house pressure, and whether your chart can carry Saturn's discipline cleanly.",
      lead: "Sade Sati should not be read from Moon sign alone. Your natal Shani, active dasha, and house pressure decide whether this phase feels like delay, discipline, family pressure, career restructuring, or inner heaviness.",
      fit: "Best when you already know or suspect Sade Sati and want a chart-level answer before doing heavy Shani remedies.",
      why_now:
        "Sade Sati can last 7.5 years, but every phase is different. Knowing whether you are in the rising, peak, or setting part changes what to avoid and what to build.",
      checkpoints: [
        "Current Sade Sati phase from your Moon sign",
        "Natal Shani placement and strength",
        "Dasha context so Shani is not blamed for everything",
        "Simple Shani upay matched to your chart",
      ],
      what_inside: [
        "Your current Sade Sati phase and the house pressure it creates from Moon sign",
        "Natal Shani placement, aspects, and whether Saturn is acting as a teacher or blocker",
        "Current mahadasha and antardasha context so the phase is not read in isolation",
        "Career, family, money, sleep, and mental-pressure areas separated clearly",
        "Chart-specific Shani upay: mantra, donation, Saturday discipline, and practical restraint",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Moon-sign Sade Sati logic is combined with natal Saturn and dasha context",
        "Upay guidance is light, consistent, and chart-specific, not fear-based",
        "Built from the same kundali engine that powers Ishvaram chat and private reports",
      ],
      faqs: [
        {
          a: "No. Sade Sati is Shani testing discipline, maturity, and responsibility. The report separates pressure from actual danger by reading your Moon sign, natal Shani, house placement, and active dasha together.",
          q: "Is Sade Sati always bad?",
        },
        {
          a: "Date of birth, time of birth, and birth place. The Moon sign and house context decide the phase, so birth details should be as accurate as possible.",
          q: "What details do I need?",
        },
        {
          a: "Yes. It gives Shani upay matched to your chart: mantra, donation, Saturday discipline, restraint, and when a stronger shanti route is actually needed.",
          q: "Will it give remedies?",
        },
      ],
      value_focus: "Current Sade Sati phase from your Moon sign",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
  transit_forecast: {
    plan_id: "transit_forecast",
    catalog_sku: "ISH-DR-015",
    intent: "chart_report",
    status: "active",
    content_slug: "gochar-transit",
    meta_description:
      "Personal gochar report: Shani and Guru transits over your chart, the key ingress dates, the houses each transit activates, and a 12-month timing map read from your Moon sign.",
    en: {
      eyebrow: null,
      title: "Gochar Transit Forecast — Saturn & Jupiter Timing | Ishvaram",
      description:
        "Personal gochar report: Shani and Guru transits over your chart, the key ingress dates, the houses each transit activates, and a 12-month timing map read from your Moon sign.",
      hero_pain:
        "Why does one year lift everything you touch and the next make the same effort feel like walking uphill?",
      hero_vedic:
        "The climate around you is set by gochar — the live transits of Shani and Guru over your chart. The Gochar Transit Forecast maps where Saturn and Jupiter are moving through your houses and when the pressure and the openings actually arrive.",
      lead: null,
      fit: null,
      why_now:
        "A gochar window opens and closes on the planet's schedule, not yours. Reading Saturn and Jupiter's next ingress before you commit is how you time the move instead of fighting it.",
      checkpoints: [],
      what_inside: [
        "Shani (Saturn) and Guru (Jupiter) gochar over your chart from your Moon sign",
        "Key ingress dates — when each planet changes rashi and the climate shifts",
        "The houses each transit activates and the life area it presses or opens",
        "A 12-month timing map: the windows to act and the windows to hold",
        "Gochar upay for the transit creating the most pressure in your chart",
        "Readable private PDF delivered through a secure Ishvaram report link",
      ],
      trust_lines: [
        "Transits are read house-by-house from your Moon sign, not a generic sun-sign forecast",
        "Ingress dates are engine-computed against authoritative Panchang references",
        "Timing map is decision-oriented — act and hold windows, not vague predictions",
      ],
      faqs: [
        {
          a: "A monthly horoscope is written for a whole rashi. The Gochar Transit Forecast reads Saturn and Jupiter moving through your own houses from your Moon sign, with the exact ingress dates and the 12-month windows that matter for your chart.",
          q: "How is this different from a monthly horoscope?",
        },
        {
          a: "Sade Sati is Shani's phase over your Moon sign specifically. The gochar forecast is broader — it covers both Shani and Guru transits across all your houses. If Sade Sati is your main concern, the Sade Sati report goes deeper on that one phase.",
          q: "Is this the same as a Sade Sati report?",
        },
        {
          a: "The transits are read from your Moon sign, which comes from your birth details. A more accurate birth time sharpens the house-by-house read of where each transit lands.",
          q: "Do I need my exact birth time?",
        },
      ],
      value_focus: "Shani (Saturn) and Guru (Jupiter) gochar over your chart from your Moon sign",
    },
    hi: {
      eyebrow: null,
      title: null,
      description: null,
      hero_pain: null,
      hero_vedic: null,
      lead: null,
      fit: null,
      why_now: null,
      checkpoints: [],
      what_inside: [],
      trust_lines: [],
      faqs: [],
      value_focus: null,
    },
  },
} as const;
export type ReportSalesCopyPlanId = keyof typeof reportSalesCopyByPlanId;
